import { useMemo } from "react";
import { Button } from "react-bootstrap";

function DeviceModeButton({ data, mode, text, danger, onClick }) {
    const variant = useMemo(() => {
        let variant = "";
        
        if (data?.machineData?.fitnessMachineControlPoint !== mode) {
            // not the current mode
            variant = "outline-"
        }

        if (danger) {
            variant += "danger";
        } else {
            variant += "primary";
        }

        return variant;
    }, [data, mode, danger]);

    return (
        <Button
            variant={variant}
            onClick={() => onClick(mode)}
        >
            {text}
        </Button>
    );
};

export default DeviceModeButton;
